import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const Breadcrumbs = ({ items }) => (
  <nav className="max-w-7xl mx-auto px-5 lg:px-12 pt-6 text-sm" aria-label="Breadcrumb" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1 text-zinc-500">
      {items.map((it, i) => (
        <li key={it.path} className="flex items-center gap-1">
          {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-zinc-700" />}
          {i === items.length - 1 ? (
            <span className="text-zinc-300">{it.name}</span>
          ) : (
            <Link to={it.path} className="hover:text-[#C69453]">{it.name}</Link>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumbs;
